import {
  ArrowIcon,
  CheckmarkIcon,
  CogWheelIcon,
  CreditIcon,
  DocumentIcon,
  FavoriteIcon,
  PulseIcon,
  TotalCasesIcon
} from './icons'
import { useEffect, useState } from 'react'
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle } from './Dialog'
import { CreateFinanceApplication, SubmitCheckmark } from './CreateFinanceApplication'
import { useUserContext } from '../../../context/UserProvider'
import { useQuery } from 'react-query'
import axios from 'axios'

export function DealerView() {
  const [open, setOpen] = useState(false)
  const [searchString, setSearchString] = useState('')
  const user = useUserContext() as any
  const { isLoading, isFetching, data, isError, refetch } = useQuery({
    queryKey: ['flows'],
    queryFn: async () => {
      const data = await axios.get(`/api/flows?flowDefinitionId=initiate-contract&sort=createdAt&dir=-1`, {
        headers: {
          Authorization: `Bearer ${user.newUserData?.access_token}`
        }
      })
      return data.data?.flows
    }
  })

  const completedApplications = data?.filter((d) => d.data.currentContractDetails.Contract.ContractStatus === 9)
  const ongoingApplications = data?.filter((d) => d.data.currentContractDetails.Contract.ContractStatus !== 9)
  const lastId = data?.[0]?.referenceId
  return (
    <div className="xl:px-16 pl-12 pt-12 pb-24 popUp flex items-start gap-8 justify-start flex-col w-full">
      <div className="w-full flex justify-between items-center">
        <p className="text-2xl">Hello, {user.newUserData.profile.name}!</p>
      </div>
      <div className="grid grid-cols-[2fr_1fr] xl:grid-cols-[3fr_1fr] gap-8 w-full">
        {isLoading ? (
          <div className="w-full h-full flex items-center justify-center flex-col gap-8">
            <div className="w-8 h-8 animate-spin bg-transparent border-2 border-t-primary rounded-full" />
            <p>Loading...</p>
          </div>
        ) : (
          <div className="flex flex-col gap-8 popUp">
            <div className="grid grid-cols-1 xl:grid-cols-[2fr_1fr] gap-8">
              {
                <div className="flex flex-col gap-4">
                  <p className="text-lg font-bold p-0 pt-2">Ongoing Applications</p>
                  <SearchTasks setSearchString={setSearchString} />
                  <TaskList data={ongoingApplications} searchString={searchString} />
                </div>
              }
              <div className="flex flex-col gap-4">
                <p className="text-lg font-bold p-0 pt-2">Overview</p>
                <TaskOverview data={data} completed={completedApplications} onGoing={ongoingApplications} />
                <p className="text-lg font-bold p-0 pt-2">Recently Completed</p>
                <CompletedTaskList completedApplications={completedApplications} />
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col gap-4">
          <Actions setOpen={setOpen} />
          <DealerTopMenu />
        </div>
      </div>
      <Dialog open={open} onOpenChange={() => setOpen(!open)}>
        <DialogContent className="min-w-[800px]">
          <DialogHeader>
            <DialogTitle>
              <p className="font-normal text-2xl pl-4">Create Finance</p>
            </DialogTitle>
          </DialogHeader>
          <CreateFinanceApplication lastId={lastId} />
          <DialogClose asChild>close</DialogClose>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export function Actions({ setOpen }) {
  const [hoverFinance, setHoverFinance] = useState(false)
  const [hoverArchive, setHoverArchive] = useState(false)
  return (
    <div className="flex flex-col gap-4">
      <p className="text-lg font-bold p-0 pt-2">Actions</p>
      <div className="flex flex-col xs:flex-row gap-2 w-full">
        <button
          onMouseEnter={() => setHoverFinance(true)}
          onMouseLeave={() => setHoverFinance(false)}
          onClick={() => setOpen(true)}
          className="w-full  bg-primary text-background justify-center h-28 text-center border-primary border-2 items-center text-backgrobg-background rounded-md shadow-md px-8 flex flex-col"
        >
          {hoverFinance ? (
            <div className="popUp">
              <div className="animate-bounce">
                <DocumentIcon />
              </div>
            </div>
          ) : (
            <p className="popUp">Create Contract</p>
          )}
        </button>
        <a
          onMouseEnter={() => setHoverArchive(true)}
          onMouseLeave={() => setHoverArchive(false)}
          target="_blank"
          href="https://fleet.blue.link-demo.stacc.dev/account/login?ReturnUrl=%2FHome%2FProfile"
          className="w-full bg-background text-center justify-center  items-center text-primary border-primary border-2 rounded-md shadow-md px-8 h-28 flex flex-col"
        >
          {hoverArchive ? (
            <div className="popUp text-black">
              <div className="animate-spin text-black">
                <CogWheelIcon />
              </div>
            </div>
          ) : (
            <p className="popUp">Configure Car</p>
          )}
        </a>
      </div>
    </div>
  )
}

export function DealerTopMenu({}) {
  const news = [
    {
      title: 'Electric Vehicles See Rising Demand in Leasing Market',
      ingress:
        'The popularity of electric vehicles continues to grow, with EVs now representing a significant portion of new lease agreements. Explore the factors driving this shift.',
      date: '2024-11-26'
    },
    {
      title: 'New Tax Policies Bring Cost Savings for Vehicle Leasing',
      ingress:
        'Updated tax regulations are reducing costs for leased vehicles, providing financial relief to lessees. Learn more about these changes and their impact.',
      date: '2024-11-20'
    },
    {
      title: 'Trends in Vehicle Leasing: What’s Changing in 2024',
      ingress:
        'From evolving consumer preferences to advancements in technology, discover the key trends shaping the vehicle leasing market this year.',
      date: '2024-11-15'
    }
  ]

  const [hoverFinance, setHoverFinance] = useState(false)
  const [hoverArchive, setHoverArchive] = useState(false)

  const [activeNews, setActiveNews] = useState(0)
  return (
    <div className="w-full  gap-8  text-sm flex flex-col">
      <div className="flex flex-col gap-4">
        <p className="text-lg font-bold p-0 pt-2">Latest News</p>
        {news.map((n, index) => {
          return (
            <div className="flex border flex-col gap-2 bg-background px-6 pt-6 pb-4 rounded-md shadow-md">
              {index === 0 && <img className="rounded-xl" src="/newsImage.png" alt="image" />}
              <p className={`${index !== 0 ? 'line-clamp-1' : 'pt-2'} font-bold text-[14px]`}>{n.title}</p>
              <p className={`${index !== 0 && 'line-clamp-1'} text-sm text-ellipsis italic`}>{n.ingress}</p>
              <div className="flex justify-between py-2">
                <p className="text-xs text-gray-500">{n.date}</p>
                <a className="flex gap-2 items-center text-xs text-primary underline">Read more</a>
              </div>
            </div>
          )
        })}
      </div>
      <a className="w-full  text-background bg-primary border-primary border-2 items-center text-backgrobg-background rounded-md shadow-md p-4 flex flex-col">
        All news
      </a>
    </div>
  )
}

export function TaskOverview({ data, completed, onGoing }) {
  return (
    <div className="flex w-full gap-4">
      <div className="flex flex-col gap-4">
        <div className="min-w-[200px] border relative flex-row justify-between items-center  shadow-md text-primary bg-background rounded-md flex p-4 gap-4">
          <div className="h-8 w-8 bg-primary text-background rounded-md top-4 right-4 absolute flex items-center justify-center">
            <TotalCasesIcon />
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <p className="text-sm text-gray-500">Total Applications</p>
              <p className="text-4xl font-bold">{data?.length}</p>
            </div>
          </div>
        </div>
        <div className="min-w-[200px] border relative flex-row justify-between items-center  shadow-md text-primary bg-background rounded-md flex p-4 gap-4">
          <div className="h-8 w-8 bg-primary text-background rounded-md top-4 right-4 absolute flex items-center justify-center">
            <FavoriteIcon />
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <p className="text-sm text-gray-500">Your Applications</p>
              <p className="text-4xl font-bold">0</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <div className="min-w-[200px] border relative flex-row justify-between items-center  shadow-md text-primary bg-background rounded-md flex p-4 gap-4">
          <div className="h-8 w-8 bg-primary text-background rounded-md top-4 right-4 absolute flex items-center justify-center">
            <PulseIcon />
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <p className="text-sm text-gray-500">Ongoing Applications</p>
              <p className="text-4xl font-bold">{onGoing?.length}</p>
            </div>
          </div>
        </div>
        <div className="min-w-[200px] border relative flex-row justify-between items-center  shadow-md text-primary bg-background rounded-md flex p-4 gap-4">
          <div className="h-8 w-8 bg-primary text-background rounded-md top-4 right-4 absolute flex items-center justify-center">
            <CheckmarkIcon />
          </div>
          <div className="flex flex-col gap-4">
            <div>
              <p className="text-sm text-gray-500">Completed Applications</p>
              <p className="text-4xl font-bold">{completed?.length}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function SearchTasks({ setSearchString }) {
  return (
    <div className="w-full">
      <input
        className="py-6 border px-4 rounded-md shadow-md font-normal text-sm w-full focus-visible:px-8 transition-all ease-in-out"
        onChange={(e) => setSearchString(e.target.value)}
        type="text"
        placeholder="Search applications"
      />
    </div>
  )
}

export function TaskList({ data, searchString }) {
  const [taskType, setTaskType] = useState('all')
  const [amountToShow, setAmountToShow] = useState(10)

  const taskTypes = [
    {
      label: 'All',
      value: 'all'
    },

    {
      label: 'Credit',

      value: 'credit'
    },

    {
      label: 'Documentation',
      value: 'documentation'
    },

    {
      label: 'Followed',
      value: 'followed'
    }
  ]
  const mappedData = data?.map((flow) => {
    const contract = flow?.data?.currentContractDetails?.Contract
    return {
      status: contract?.ContractStatus,
      person: contract?.FinancialPartner,
      contractId: flow?.referenceId,
      vehicle: {
        brand: contract?.Vehicle?.BrandName,
        modelName: contract?.Vehicle?.ModelName,
        modelYear: contract?.Vehicle?.ModelYear
      }
    }
  })

  useEffect(() => {
    setAmountToShow(10)
  }, [taskType])

  if (!mappedData || mappedData?.length === 0) return null

  const filteredData = mappedData?.filter((d) => {
    if (!searchString) return true
    return (
      d.contractId.toLowerCase().includes(searchString.toLowerCase()) ||
      d.person.toLowerCase().includes(searchString.toLowerCase()) ||
      d.vehicle.brand.toLowerCase().includes(searchString.toLowerCase()) ||
      d.vehicle.modelName.toLowerCase().includes(searchString.toLowerCase())
    )
  })
  return (
    <div className="flex flex-col border bg-background shadow-md rounded-md ">
      <div className="flex border-b ">
        {taskTypes.map((t) => (
          <button
            onClick={() => setTaskType(t.value)}
            className={`px-8 py-4 w-full text-center ${
              taskType === t.value ? 'border-b-primary border-b-2' : 'border-b-2 border-b-backgrobg-background'
            } `}
          >
            {t.label}
          </button>
        ))}
      </div>
      {taskType === 'followed' && (
        <div className="flex p-8 min-h-[300px] flex-col bg-background shadow-md rounded-md items-center justify-center">
          <p>You are not following any applications at the moment</p>
        </div>
      )}
      {taskType === 'documentation' && (
        <div className="flex p-8 min-h-[300px] flex-col bg-background shadow-md rounded-md items-center justify-center">
          <p>No applications requiring documentation control</p>
        </div>
      )}
      {(taskType === 'all' || taskType === 'credit') && (
        <div>
          {filteredData.slice(0, amountToShow).map((item) => {
            return <TaskItem data={item} />
          })}
          {amountToShow < mappedData.length && (
            <div className="p-4">
              <button
                onClick={() => setAmountToShow(mappedData.length)}
                className="w-full text-background  bg-primary border-primary border-2 items-center text-backgrobg-background rounded-md shadow-md p-4 flex flex-col"
              >
                Show more
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export function TaskItem({ data }) {
  const level = ((findLevel(data?.status).level / 4) * 100).toString()
  return (
    <a
      href={`/contract/${data?.contractId}`}
      className="flex popUp items-center justify-between cursor-pointer px-8 py-6 hover:bg-gray-100"
    >
      <div className="flex items-center gap-8 ">
        <p className="w-[5ch]">{data?.contractId}</p>
        <div className="h-12 w-12 rounded-xl bg-primary text-gray-200 flex items-center justify-center">
          <CreditIcon />
        </div>
        <div className="w-[20ch]">
          <p className="text-lg font-bold text-ellipsis line-clamp-1">
            {data.vehicle.brand} - {data.vehicle.modelName}
          </p>
          <p className="text-sm text-gray-500">{data.person}</p>
        </div>
      </div>
      <div className=" h-full gap-2 text-primary text-left rounded-md px-2 w-[200px] flex flex-col">
        <p className="text-ellipsis line-clamp-1 text-sm">Status: {findLevel(data?.status).text}</p>
        <div className="relative w-full bg-gray-300 h-[12px] rounded-full">
          <div style={{ width: `${level}%` }} className={`absolute h-full bg-primary rounded-full`}></div>
        </div>
      </div>
      <ArrowIcon />
    </a>
  )
}

export function CompletedTaskList({ completedApplications }) {
  const mappedData = completedApplications?.map((flow) => {
    const contract = flow?.data?.currentContractDetails?.Contract
    return {
      status: contract?.ContractStatus,
      person: contract?.FinancialPartner,
      contractId: flow?.referenceId,
      vehicle: {
        brand: contract?.Vehicle?.BrandName,
        modelName: contract?.Vehicle?.ModelName,
        modelYear: contract?.Vehicle?.ModelYear
      }
    }
  })
  if (!mappedData || mappedData?.length === 0) return null
  return (
    <div className="flex flex-col border bg-background shadow-md rounded-md ">
      <div className="">
        {mappedData?.slice(0, 3)?.map((item) => {
          return <CompletedTaskItem data={item} />
        })}
      </div>
      <div className="p-4">
        <a className="w-full  bg-primary border-primary text-background border-2 items-center  rounded-md shadow-md p-4 flex flex-col">
          To Archive
        </a>
      </div>
    </div>
  )
}

export function CompletedTaskItem({ data }) {
  console.log(data)
  return (
    <a className="flex items-center justify-between px-8 py-4 hover:bg-gray-100">
      <div className="flex items-center gap-8 text-primary">
        <p>{data.contractId}</p>
        <div className="h-12 w-12 [&>*]:scale-50 rounded-md bg-primary text-gray-200 flex items-center justify-center">
          <SubmitCheckmark />
        </div>
        <div className="max-w-[20ch]">
          <p className="text-lg font-bold text-ellipsis line-clamp-1">
            {data.vehicle.brand} - {data.vehicle.modelName}
          </p>
          <p className="text-sm text-gray-500">{data.person}</p>
        </div>
      </div>
      <div className="text-primary">
        <ArrowIcon />
      </div>
    </a>
  )
}

export const findLevel = (status) => {
  switch (status) {
    case 1:
      return {
        level: 1,
        color: '#467EFF',
        text: 'Created'
      }
    case 2:
      return {
        level: 1,
        color: '#467EFF',
        text: 'Ready for Credit Assessment'
      }
    case 11:
      return {
        level: 1,
        color: '#467EFF',
        text: 'Awaiting Customer Information'
      }
    case 3:
      return {
        level: 1,
        color: '#467EFF',
        text: 'Awaiting Credit Assessment'
      }
    case 4:
      return {
        level: 2,
        color: '#467EFF',
        text: 'Credit Approved Conditionally'
      }
    case 5:
      return {
        level: 2,
        color: '#467EFF',
        text: 'Credit Approved'
      }
    case 6:
      return {
        level: 2,
        color: 'red',
        text: 'Credit Rejected'
      }
    case 7:
      return {
        level: 2,
        color: '#467EFF',
        text: 'Contract Ready for Signing'
      }
    case 8:
      return {
        level: 2,
        color: '#467EFF',
        text: 'Contract Signed'
      }
    case 10:
      return {
        level: 2,
        color: '#467EFF',
        text: 'Contract Approved'
      }
    case 12:
      return {
        level: 3,
        color: '#467EFF',
        text: 'Ready to Activate'
      }
    case 9:
      return {
        level: 4,
        color: 'green',
        text: 'Active'
      }
    default:
      return {
        level: 0,
        color: 'lightgray',
        text: 'What?'
      }
  }
}
